import { useSelector } from 'react-redux';

import useUploadForm from 'app/hooks/useUploadForm';

import {
  getUpload,
  createUpload,
  createMoments,
  updateUpload
} from 'app/services/uploads';

import {
  updateMoment
} from 'app/services/moments';

import {
  randomString
} from 'shared/utils/Utils';

import {
  MOMENT_UPLOAD_URL
} from 'app/utils/Constants';

const useMomentsUploadForm = props => {
  const {
    jobId,
    customerId,
    storyIds,
    onUploadStart,
    onMomentComplete,
    onUploadComplete,
    job,
    customer,
    defaultMomentsOnly,
    customersOnly
  } = props;

  const account = useSelector(state => state.portalReducer.account);

  const createFileContexts = async params => {
    // the original file objects shouldn't be altered
    const files = Array.from(params.files);

    const {
      job_id,
      customer_ids,
      story_ids
    } = params;

    let upload = await createUpload(account.id, {});

    let fileParams = {
      job_id,
      customer_ids,
      story_ids
    }

    let momentParams = {
      upload_id: upload.id,
      files: files.map(f => ({
        name: f.name,
        type: f.type,
        size: f.size,
        hash: randomString(),
        ...fileParams
      }))
    }

    let moments = await createMoments(momentParams);

    // refresh upload object to get moment upload records
    upload = await getUpload(account.id, upload.id);

    if (onUploadStart) {
      onUploadStart(upload, { job, customer });
    }

    // moments should match to files via their filename field.
    // if need be this can be refactored to rely on their order instead
    let fileContexts = moments.map(moment => {
      let file = files.find(f => f.name === moment.filename);
      return {
	id: moment.id,
	groupId: upload.id,
	uploadUrlEndpoint: MOMENT_UPLOAD_URL(moment.id, file.type, true),
        defaultMomentsOnly,
        customersOnly,
	...fileParams
      }
    });

    return fileContexts;
  }

  const onFileComplete = async fileContext => {
    let momentId = fileContext.id;
    let moment = await updateMoment(momentId, { uploaded: 'true' });

    if (onMomentComplete) {
      onMomentComplete(moment);
    }
  }

  const onGroupComplete = async groupContext => {
    let uploadId = groupContext.groupId;
    let upload = await updateUpload(account.id, uploadId, { complete: true });

    if (onUploadComplete) {
      onUploadComplete(upload, { job, customer });
    }
  }

  const {
    formIsOpen,
    onFormClose,
    onFormSubmit,
    onAdd,
  } = useUploadForm({
    createFileContexts,
    onFileComplete,
    onGroupComplete
  });

  return {
    formIsOpen,
    onAdd,
    onFormClose,
    onFormSubmit
  }
}

export default useMomentsUploadForm;
